import {qspostfile} from '@/plugins/axios'

/*
 * 居民信息导出
 * @constructor jack
 * */
export const exportJuMinList = (searchName, searchPhone,searchHuJiDi,searchIdCard,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchSex,searchHuKouXingZhi,searchHuZhuGuanXi,searchShengRiStatus) => qspostfile('/Index/Export/exportJuMinList', {searchName, searchPhone,searchHuJiDi,searchIdCard,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchSex,searchHuKouXingZhi,searchHuZhuGuanXi,searchShengRiStatus})

/*
 * 房屋信息导出
 * @constructor jack
 * */
export const exportRroomList = (searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchFangWuXingZhi,searchJuZhuQingKuang) => qspostfile('/Index/Export/exportRroomList', {searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchFangWuXingZhi,searchJuZhuQingKuang})

/*
 * 物业情况列表
 * @constructor jack
 * */
export const exportWuYeQingKuang = (searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, searchNianDu, searchShouFeiXiangMu) => qspostfile('/Index/Export/exportWuYeQingKuang', {
  searchXiangMuId,
  searchSheQuId,
  searchLouId,
  searchMenId,
  searchHuId,
  searchNianDu,
  searchShouFeiXiangMu
})

/*
* 独立民调 - 民调范围 - 民调结果列表导出
*  * @constructor jack
* */
export const exportMinDiao = (duLiMinDiaoId,status) => qspostfile('/Index/Export/exportDuLiMinDiaoList', {
  duLiMinDiaoId,status
})
